import React, { useEffect, useState } from 'react';
import { Box, Checkbox,  FormControl, TextField,Autocomplete } from '@mui/material';
//import { AutocompleteRenderInputParams } from '@mui/lab';
//import { AutocompleteRenderInputParams } from '@mui/material';
import { isDataLoaded, SiteInfo } from '../../types';
import userStyles from '../../app/user-management/UserStyle';

import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';

import { useRefreshLocationList } from '../../hooks/data-hooks';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export const LocationAutoComplete: React.FC<{
    index: number;
    updatedLocation: Function;
    selectedLocation: SiteInfo[];
}> = (props) => {
    const classes = userStyles();
    const locationListData = useRefreshLocationList();
    const locationData = isDataLoaded(locationListData) ? locationListData.value.locations : [];
    const [accessLocation, setAccessLocation] = useState<SiteInfo[]>([]);
    const [allLocationData, setAllLocationData] = useState<
        Array<{
            siteId: string;
            siteName: string;
        }>
    >([]);

    useEffect(() => {
        const data = locationData.map((x) => ({
            siteId: x.locationId,
            siteName: x.locationName,
        }));
        setAllLocationData(data);
    }, [locationData]);
    const locationChange = (newValue: SiteInfo[]): void => {
        setAccessLocation(newValue);
        const locationWithIndex = { index: props.index, selectedlocation: newValue };
        props.updatedLocation(locationWithIndex);
    };

    const optionDisabled = (option: SiteInfo): boolean =>
        props.selectedLocation.some((selected) => selected.siteId === option.siteId);
    return (
        <div>
            <Box
                data-testid="location"
                display="flex"
                flexDirection="column"
                alignItems="left"
                width="100%"
                marginBottom={1}
                marginLeft={-1}
            >

                <FormControl className={classes.addUserformControl} variant="standard" style={{ width: '100%' }}>
                    <Autocomplete
                        data-testid="location-autosuggest"
                        multiple
                        value={accessLocation}
                        id="multiple-location"
                        placeholder="autosuggest"
                        options={allLocationData}
                        getOptionLabel={(option: { siteId: string; siteName: string }): string => option.siteName}
                        disableCloseOnSelect
                        isOptionEqualToValue={(option, value): boolean => option.siteId === value.siteId}
                        getOptionDisabled={(option): boolean => optionDisabled(option)}
                        onChange={(event, newvalue): void => {
                            locationChange(newvalue);
                        }}
                        // renderTags={(value: SiteInfo[], getTagProps): React.ReactNode =>
                        //     value.map((option: SiteInfo, index: number) => (
                        //         <Chip
                        //             color="primary"
                        //             label={option.siteName}
                        //             {...getTagProps({ index })} />
                        //     ))
                        // }
                        renderOption={(prop, option: SiteInfo, { selected }): JSX.Element => (
                            <li {...prop}>
                                <Checkbox
                                    icon={icon}
                                    checkedIcon={checkedIcon}
                                    style={{ marginRight: 8 }}
                                    checked={selected}
                                    data-testid="location-checkbox"
                                />
                                {option.siteName}
                            </li>
                        )}

                        //style={{ width: 450 }}
                        renderInput={(params): React.ReactNode => (
                            <TextField
                                data-testid="multipleLocationsTxt"
                                {...params}
                                variant="filled"
                                required
                                label="Assign to Location(s)"
                                placeholder=""

                            />
                        )}
                    />
                </FormControl>
            </Box>
        </div>
    );
};
